function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Input } from "../../../native";
import { useFormContext } from "../FormContext";

const UpDownWidget = ({
  id,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  formContext
}) => {
  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Input, _extends({}, mapping.input, {
    style: [mapping.input.style],
    autoFocus: autofocus // type="number"
    ,
    disabled: disabled || readonly,
    label: label,
    value: value !== null && value !== void 0 ? value : '',
    onChangeText: onChange,
    onBlur: () => onBlur(id, value !== null && value !== void 0 ? value : ''),
    onFocus: () => onFocus(id, value)
  }));
};

export default UpDownWidget;